import axios from 'axios';
import { useConfig } from '@/helpers/config-effect';

const config = useConfig();

export const restApiHttpClient = axios.create({
  baseURL: config.url.api.base,
  headers: {
    'X-WP-Nonce': config.url.api.nonce,
  },
});
